module.exports = __webpack_public_path__ + "img/video03.83e0ea7c.jpg";